var _g, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSEtcEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 40,
    viewBox: "0 0 65 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1691_1961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18C4 9.16344 11.1634 2 20 2H45C53.8366 2 61 9.16344 61 18C61 26.8366 53.8366 34 45 34H20C11.1634 34 4 26.8366 4 18Z",
    fill: "#282D4B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9443 21.0034V22H36.0503V21.0034H40.9443ZM36.2979 12.7578V22H35.0728V12.7578H36.2979ZM40.2969 16.7314V17.728H36.0503V16.7314H40.2969ZM40.8809 12.7578V13.7607H36.0503V12.7578H40.8809ZM44.1592 15.1318V16.0332H40.4458V15.1318H44.1592ZM41.7026 13.4624H42.877V20.2988C42.877 20.5316 42.9129 20.7072 42.9849 20.8257C43.0568 20.9442 43.1499 21.0225 43.2642 21.0605C43.3784 21.0986 43.5011 21.1177 43.6323 21.1177C43.7297 21.1177 43.8312 21.1092 43.937 21.0923C44.047 21.0711 44.1296 21.0542 44.1846 21.0415L44.1909 22C44.0978 22.0296 43.9751 22.0571 43.8228 22.0825C43.6746 22.1121 43.4948 22.127 43.2832 22.127C42.9954 22.127 42.731 22.0698 42.4897 21.9556C42.2485 21.8413 42.056 21.6509 41.9121 21.3843C41.7725 21.1134 41.7026 20.7495 41.7026 20.2925V13.4624ZM47.2852 21.1621C47.5645 21.1621 47.8226 21.105 48.0596 20.9907C48.2965 20.8765 48.4912 20.7199 48.6436 20.521C48.7959 20.3179 48.8826 20.0872 48.9038 19.8291H50.021C49.9998 20.2354 49.8623 20.6141 49.6084 20.9653C49.3587 21.3123 49.0308 21.5938 48.6245 21.8096C48.2183 22.0212 47.7718 22.127 47.2852 22.127C46.7689 22.127 46.3182 22.036 45.9331 21.854C45.5522 21.672 45.2349 21.4224 44.981 21.105C44.7313 20.7876 44.543 20.4237 44.416 20.0132C44.2933 19.5985 44.2319 19.1605 44.2319 18.6992V18.4326C44.2319 17.9714 44.2933 17.5355 44.416 17.125C44.543 16.7103 44.7313 16.3442 44.981 16.0269C45.2349 15.7095 45.5522 15.4598 45.9331 15.2778C46.3182 15.0959 46.7689 15.0049 47.2852 15.0049C47.8226 15.0049 48.2923 15.1149 48.6943 15.335C49.0964 15.5508 49.4116 15.847 49.6401 16.2236C49.8729 16.596 49.9998 17.0192 50.021 17.4932H48.9038C48.8826 17.2096 48.8022 16.9536 48.6626 16.7251C48.5272 16.4966 48.341 16.3146 48.104 16.1792C47.8713 16.0396 47.5983 15.9697 47.2852 15.9697C46.9255 15.9697 46.6229 16.0417 46.3774 16.1855C46.1362 16.3252 45.9437 16.5156 45.7998 16.7568C45.6602 16.9938 45.5586 17.2583 45.4951 17.5503C45.4359 17.8381 45.4062 18.1322 45.4062 18.4326V18.6992C45.4062 18.9997 45.4359 19.2959 45.4951 19.5879C45.5544 19.8799 45.6538 20.1444 45.7935 20.3813C45.9373 20.6183 46.1299 20.8088 46.3711 20.9526C46.6165 21.0923 46.9212 21.1621 47.2852 21.1621Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 23.3334C24.9455 23.3334 27.3333 20.9456 27.3333 18.0001C27.3333 15.0546 24.9455 12.6667 22 12.6667C19.0544 12.6667 16.6666 15.0546 16.6666 18.0001C16.6666 20.9456 19.0544 23.3334 22 23.3334ZM22 24.3334C25.4978 24.3334 28.3333 21.4979 28.3333 18.0001C28.3333 14.5023 25.4978 11.6667 22 11.6667C18.5022 11.6667 15.6666 14.5023 15.6666 18.0001C15.6666 21.4979 18.5022 24.3334 22 24.3334Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18.0001C23 18.5524 22.5522 19.0001 22 19.0001C21.4477 19.0001 21 18.5524 21 18.0001C21 17.4478 21.4477 17.0001 22 17.0001C22.5522 17.0001 23 17.4478 23 18.0001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18.0001C26 18.5524 25.5522 19.0001 25 19.0001C24.4477 19.0001 24 18.5524 24 18.0001C24 17.4478 24.4477 17.0001 25 17.0001C25.5522 17.0001 26 17.4478 26 18.0001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.0001C20 18.5524 19.5522 19.0001 19 19.0001C18.4477 19.0001 18 18.5524 18 18.0001C18 17.4478 18.4477 17.0001 19 17.0001C19.5522 17.0001 20 17.4478 20 18.0001Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1691_1961",
    x: 0,
    y: 0,
    width: 65,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1691_1961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1691_1961",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSEtcEn);
export default __webpack_public_path__ + "static/media/s_etc_en.cbe17fc102e6e7e6a56b5784676d118b.svg";
export { ForwardRef as ReactComponent };